module.exports = __webpack_public_path__ + "img/cockft.e90ce107.png";